import { Outlet } from "react-router";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useApplyBrand, useApplyFavicon } from "@/hooks/use-brand";
import { useEmailLocaleMirror } from "@/hooks/use-email-locale-mirror";
import { AppSidebar } from "./app-sidebar";
import { TopBar } from "./top-bar";

export function AppLayout() {
  // Here rather than in `App`, so the pre-auth screens are outside it: the organisation is
  // unknown before sign-in, and this is what makes "/login stays FoodSight" structural rather
  // than a rule someone has to remember (POS2-1132).
  useApplyBrand();
  useApplyFavicon();
  // Alongside the brand and for the same structural reason: there is no session to write a locale
  // to before sign-in, and the two emails this feeds are GoTrue's (POS2-1160).
  useEmailLocaleMirror();

  return (
    <SidebarProvider>
      <AppSidebar />
      {/* min-w-0: the inset is a flex item, so without it its min-width resolves to
          min-content — the widest table on the page. It then cannot shrink to the viewport,
          which pushed the whole page wider than the window (taking page-header actions
          off-screen to the right) and meant a table's own `overflow-x-auto` never engaged,
          because the card had already been granted its full content width. The design mock
          carries the same declaration on its main column (`.main{flex:1;min-width:0}`). */}
      <SidebarInset className="min-w-0">
        <TopBar />
        {/* print:overflow-visible so a PDF paginates the content instead of rendering a scrollbar. */}
        <div className="relative flex-1 overflow-auto p-6 print:overflow-visible">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
